export const DAIRY_CLASSES = [
  {
    value: 1,
    name: "Milking Cows"
  },
  {
    value: 2,
    name: "Heifers (1+ years)"
  },
  {
    value: 3,
    name: "Heifers (<1 year)"
  },
  {
    value: 4,
    name: "Dairy Bulls (1+ years)"
  },
  {
    value: 5,
    name: "Other Stock (<1 year)"
  },
  {
    value: 6,
    name: "Other Stock (1+ years)"
  },
]
